import Box from "@memorang/ui/components/Box";
import { CustomAppBar } from "@memorang/ui/components/CustomAppbar";
import PdfRenderer from "@memorang/ui/components/StudySession/PdfRenderer";
import { router, useLocalSearchParams } from "expo-router";

const source = {
	uri: "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/jbjs-assets/pdfs/chapman.pdf",
	cache: true,
};

const Citations = () => {
	const { pageNumber } = useLocalSearchParams<{ pageNumber: string }>();

	return (
		<>
			<CustomAppBar title="Citation source" onPressBack={() => router.back()} />
			<Box flex={1} height="100%">
				<PdfRenderer pageNumber={Number(pageNumber)} source={source} />
			</Box>
		</>
	);
};

export default Citations;
